import { Group, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import Button from "../../components/Button";
import DescriptionField from "../../components/descriptionField";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { alphaNumericRegex, descriptionRegex } from "../../constants/index";

import { addMajor } from "./postData";
export const AddMajor = ({ opened, setOpened, setUpdate }) => {
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      majorName: "",
      majorDescription: "",
    },

    validate: {
      majorName: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Alphabetic Name with 2 or more characters",
      majorDescription: (value) =>
        value?.trim()?.length > 20 && descriptionRegex.test(value.trim())
          ? null
          : "Description with 20 or more characters",
    },
  });

  const onSubmit = (values) => {
    addMajor(values, setOpened, setUpdate);
  };
  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb={0} weight={500}>
        Major Name
      </Text>
      <InputField
        width="100%"
        placeholder="Enter Major's Name"
        form={form}
        validateName="majorName"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Text mt="md" mb={0} weight={500}>
        Description
      </Text>
      <DescriptionField
        maxRows={4}
        minRows={3}
        autosize={true}
        width="100%"
        placeholder="Enter Major's Description"
        form={form}
        validateName="majorDescription"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button title={"Add"} primary={true} fontWeight="700" type="submit" />
      </Group>
    </form>
  );
  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      InternalComponent={InternalContent}
      title="Add Major"
      form={form}
    />
  );
};
